import { useUser } from '../../contexts/UserContext'
import { RetrievalControlPlane } from '../../components/RAG/RetrievalControlPlane'
import { ErrorBoundary } from '../../components/ErrorBoundary'

export function SettingsPage() {
    const { session } = useUser()

    return (
        <ErrorBoundary>
            <RetrievalControlPlane session={session} />
        </ErrorBoundary>
    )
}
